// import { CustomerType } from '@repo/common';
// import { Skeleton } from '@repo/shadcn';
// import { useEffect, useState } from 'react';
import { CustomerType } from '@repo/common';
import { Search, X } from 'lucide-react';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';

import { useAppSelector } from '../../../../features';
import { InventoryProductItemsForSale } from '../../../../features/slice/inventory/inventory.schema';
import { useGetInventoryProductForSaleQuery } from '../../../../features/slice/inventory/inventory-api-slice';
import { useDebounce } from '../../../../hooks/use-debounce';

// import { useGetInventoryProductForSaleQuery } from '@/features/slice/inventory/inventory-api-slice';

// import { useAppSelector } from '../../../../features';
// import { InventoryProductItemsForSale } from '../../../../features/slice/inventory/inventory.schema';
// import { useDebounce } from '../../../../hooks/use-debounce';

// export function SaleProductAutoComplete({
//   changeSelectedProduct,
//   value,
//   setValue,
// }: any) {
//   const [searchTerm, setSearchTerm] = useState('');
//   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
//   const { customerType } = useAppSelector((state) => state.eventSlice);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState('')
//   const debouncedSearch = useDebounce((term: string) => {
//     setDebouncedSearchTerm(term);
//   }, 300);

//   const handleSearchInput = (value: string) => {
//     setSearchTerm(value);
//     debouncedSearch(value);
//   };

//   const { data: searchData, isLoading } = useGetInventoryProductForSaleQuery({
//     limit: 50,
//     page: 1,
//     search: debouncedSearchTerm,
//   });

//   const productList = searchData?.data || [];

//   const getPriceBasedOnCustomerType = (
//     product:
//       | Pick<InventoryProductItemsForSale, 'wholesale_price' | 'retail_price'>
//       | undefined,
//   ) => {
//     if (!product) return '';
//     return customerType?.toLowerCase() === CustomerType.WHOLESALE
//       ? product.wholesale_price
//       : product.retail_price;
//   };

//   const changeSelection = (selectedId: string) => {
//     changeSelectedProduct(selectedId);
//     const selectedProduct = productList.find(
//       (product) => product.purchase_id === selectedId,
//     );
//     const price = getPriceBasedOnCustomerType(selectedProduct);
//     setValue('price', price);
//     setIsDropdownOpen(false);
//   };

//   useEffect(() => {
//     const handleKeyDown = (e: KeyboardEvent) => {
//       if (e.ctrlKey && e.key.toLowerCase() === 'x') {
//         e.preventDefault();
//         setIsDropdownOpen(true);
//       }
//     };
//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, []);

//   useEffect(() => {
//     if (value) {
//       const selectedProduct = productList.find(
//         (product) => product.purchase_id === value,
//       );
//       setSearchTerm(selectedProduct?.product_name || '')
//       setSelectedProduct(selectedProduct?.product_name || '')
//       const price = getPriceBasedOnCustomerType(selectedProduct);
//       setValue('price', price);
//     }
//   }, [customerType, value, productList]);

//   if (isLoading) {
//     return <Skeleton className="h-[40px] w-full mt-2" />;
//   }
//   return (
//     <div id="portal-root" className="relative mt-2 h-[40px]">
//       <input
//         className="w-full rounded-md h-[40px] px-4"
//         placeholder="Search Medicine..."
//         onFocus={() => setIsDropdownOpen(true)}
//         onBlur={() => setTimeout(() => setIsDropdownOpen(false), 200)}
//         onChange={(e) => {
//           handleSearchInput(e.target.value);

//         }}
//         value={searchTerm}
//       />
//       {isDropdownOpen && (
//         <div className="max-w-full max-h-[400px] overflow-auto absolute top-9 z-50 mt-2 bg-white border border-gray-300 rounded-md shadow-lg">
//           {productList.map((product) => (
//             <p
//               key={product.purchase_id}
//               onClick={() => {
//                 changeSelection(product.purchase_id);
//                 setIsDropdownOpen(false);
//               }}
//               className="py-4 px-4 hover:bg-gray-100 cursor-pointer"
//             >
//               {product.product_name}
//             </p>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

('use client');

interface Product {
    purchase_id: string;
    product_name: string;
}

export const SaleProductAutoComplete = ({
    changeSelectedProduct,
    value,
    setValue,
}: any) => {
    const [searchTerm, setSearchTerm] = useState('');
    const { customerType } = useAppSelector((state) => state.eventSlice);

    const [selectedProduct, setSelectedProduct] = useState<Product | null>(
        null,
    );
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState<number>(-1);
    const inputRef = useRef<HTMLInputElement>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

    const { data: searchData, isLoading } = useGetInventoryProductForSaleQuery({
        limit: 50,
        page: 1,
        search: debouncedSearchTerm,
    });
    const debouncedSearch = useDebounce((term: string) => {
        setDebouncedSearchTerm(term);
    }, 300);
    const products = searchData?.data || [];

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                inputRef.current &&
                !inputRef.current.contains(event.target as Node)
            ) {
                setIsDropdownOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        const selected = products.find(
            (product) => product.purchase_id === selectedProduct?.purchase_id,
        );
        setSearchTerm(selectedProduct?.product_name || '');
        const price = getPriceBasedOnCustomerType(selected);
        setValue('price', price);
    }, [customerType, value]);

    const handleSearchInput = (value: string) => {
        setSearchTerm(value);
        debouncedSearch(value);
        if (selectedProduct && value !== selectedProduct.product_name) {
            setSelectedProduct(null);
        }

        setIsDropdownOpen(true);
    };

    const selectProduct = (product: Product) => {
        setSelectedProduct(product);
        setSearchTerm(product.product_name);
        changeSelectedProduct(product.purchase_id);
        setIsDropdownOpen(false);
        const selectedProduct = products.find(
            (p) => product.purchase_id === p.purchase_id,
        );
        const price = getPriceBasedOnCustomerType(selectedProduct);
        setValue('price', price);
    };
    const getPriceBasedOnCustomerType = (
        product:
            | Pick<
                  InventoryProductItemsForSale,
                  'wholesale_price' | 'retail_price'
              >
            | undefined,
    ) => {
        if (!product) return '';
        return customerType?.toLowerCase() === CustomerType.WHOLESALE
            ? product.wholesale_price
            : product.retail_price;
    };
    const clearSelection = () => {
        setSelectedProduct(null);
        setSearchTerm('');
        setIsDropdownOpen(true);
        inputRef.current?.focus();
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!isDropdownOpen) {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                setIsDropdownOpen(true);
                setHighlightedIndex(0);
                return;
            }
            return;
        }

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                if (products.length > 0) {
                    setHighlightedIndex((prevIndex) => {
                        const newIndex =
                            prevIndex < products.length - 1 ? prevIndex + 1 : 0;
                        const element = document.getElementById(
                            `product-item-${products[newIndex].purchase_id}`,
                        );
                        element?.scrollIntoView({ block: 'nearest' });
                        return newIndex;
                    });
                }
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (products.length > 0) {
                    setHighlightedIndex((prevIndex) => {
                        const newIndex =
                            prevIndex > 0 ? prevIndex - 1 : products.length - 1;
                        const element = document.getElementById(
                            `product-item-${products[newIndex].purchase_id}`,
                        );
                        element?.scrollIntoView({ block: 'nearest' });
                        return newIndex;
                    });
                }
                break;
            case 'Enter':
                if (
                    highlightedIndex >= 0 &&
                    highlightedIndex < products.length
                ) {
                    e.preventDefault();
                    selectProduct(products[highlightedIndex]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                setIsDropdownOpen(false);
                break;

            default:
                break;
        }
    };
    useEffect(() => {
        function handleKeyPress(e: KeyboardEvent) {
            if (e.ctrlKey && e.key === 'x') {
                e.preventDefault();
                setIsDropdownOpen(true);
                inputRef.current?.focus();
            }
        }

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, []);
    useEffect(() => {
        if (isDropdownOpen && products.length > 0) {
            setHighlightedIndex(0);
        } else {
            setHighlightedIndex(-1);
        }
    }, [isDropdownOpen, products]);

    return (
        <div className="relative mt-2 w-full max-w-md">
            <div className="relative">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <Search className="h-5 w-5 text-gray-400" />
                </div>

                <input
                    ref={inputRef}
                    className="h-[40px] w-full rounded-md border border-gray-300 py-2 pl-10 pr-10 text-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-primary"
                    placeholder="Search Medicine..."
                    onFocus={() => {
                        setIsDropdownOpen(true);
                        // inputRef.current?.select()
                    }}
                    onChange={(e) => handleSearchInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    value={searchTerm}
                    aria-expanded={isDropdownOpen}
                    aria-controls="product-dropdown"
                    aria-activedescendant={
                        highlightedIndex >= 0
                            ? `product-item-${products[highlightedIndex]?.purchase_id}`
                            : undefined
                    }
                />

                {selectedProduct && (
                    <button
                        type="button"
                        onClick={clearSelection}
                        className="absolute inset-y-0 right-0 flex items-center pr-3"
                        aria-label="Clear selection"
                    >
                        <X className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                    </button>
                )}
            </div>

            {isDropdownOpen && (
                <div
                    id="product-dropdown"
                    ref={dropdownRef}
                    className="absolute z-50 mt-1 max-h-[400px] w-full overflow-y-auto rounded-md border border-gray-300 bg-white shadow-lg"
                >
                    {isLoading ? (
                        <div className="px-4 py-3 text-sm text-gray-500">
                            Loading...
                        </div>
                    ) : products.length > 0 ? (
                        products.map((product, index) => (
                            <div
                                key={product.purchase_id}
                                id={`product-item-${product.purchase_id}`}
                                onClick={() => selectProduct(product)}
                                className={`flex cursor-pointer items-center justify-between px-4 py-3 text-sm transition-colors duration-150 ${
                                    highlightedIndex === index
                                        ? 'bg-blue-100 font-medium text-blue-800'
                                        : 'hover:bg-gray-100'
                                }`}
                                role="option"
                                aria-selected={
                                    selectedProduct?.purchase_id ===
                                        product.purchase_id ||
                                    highlightedIndex === index
                                }
                            >
                                <span>{product.product_name}</span>{' '}
                                <span className="text-xs">
                                    Qty-{product.quantity}
                                </span>
                            </div>
                        ))
                    ) : (
                        <div className="px-4 py-3 text-sm text-gray-500">
                            No products found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
